module.exports = __webpack_public_path__ + "img/907.3d6d8fe8.gif";